"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const minus_1 = require("../icons/minus");
exports.default = minus_1.Minus;
